import { render } from "./order-history.vue?vue&type=template&id=56fa06af&scoped=true"
import script from "./order-history.vue?vue&type=script&lang=js"
export * from "./order-history.vue?vue&type=script&lang=js"

import "./order-history.vue?vue&type=style&index=0&id=56fa06af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fa06af"]])

export default __exports__